import { store } from "../../..";
import { API } from "../../../../legacy/api";
import * as actions from "../../Activity/Common/Activity.actions";

API.on("activity.show", () => {
  const { showing } = store.getState().activity;
  if (!showing) {
    store.dispatch(actions.showActivity());
  }
});

API.on("activity.hide", () => {
  const showing = store.getState().activity.showing;

  if (showing) {
    store.dispatch(actions.hideActivity());
  }
});
